<!-- eslint-disable vue/no-use-v-if-with-v-for -->
<template>
  <div id="maintain">
    <v-toolbar
      @click="clickTile($event)"
      class="pt-1 item-dashboard"
      color="grey lighten-4"
      flat
    >
      <v-toolbar-title v-if="!disable">
        PO by
        <span class="text-capitalize">{{ title }}</span>
        <template v-if="dateInTitle"> Date </template>
      </v-toolbar-title>
      <v-toolbar-title v-else>{{ title }}</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-flex xs3 lg3 class="mr-3">
        <v-autocomplete
          label="Province"
          v-model="provincesSelected"
          chips
          small-chips
          multiple
          :items="provinces"
          clearable
        >
          <template v-slot:selection="data">
            <v-chip
              v-if="provincesSelected.length < 2"
              v-bind="data.attrs"
              small
            >
              {{ data.item }}
            </v-chip>
            <div v-else-if="data.index === 0">
              {{ `${provincesSelected.length} items selected` }}
            </div>
          </template>
        </v-autocomplete>
      </v-flex>
      <v-menu
        :close-on-content-click="false"
        bottom
        full-width
        left
        offset-y
        class="ma-0 mr-3"
        v-model="dateMenu"
      >
        <v-btn
          class="date-range-checked ma-0"
          color="grey darken-3"
          outline
          slot="activator"
          >{{ new Date(range[0]) | morph-date("DD/MM/YYYY") }} &mdash;
          {{ new Date(range[1]) | morph-date("DD/MM/YYYY") }}</v-btn
        >
        <v-card>
          <v-card-text>
            <v-date-range
              :labels="labels"
              :options="dateRangeOptions"
              @input="onDateRangeChange"
              @cancelPicker="cancelPicker"
              @filterDateRange="filterDateRange"
            ></v-date-range>
            <!--<v-layout class="mt-2" row wrap>
                            <v-spacer></v-spacer>
                            <v-btn @click="cancelPicker()" color="primary" flat>Cancel</v-btn>
                            <v-btn @click="filterDateRange()" color="primary" flat>OK</v-btn>
                        </v-layout>-->
          </v-card-text>
        </v-card>
      </v-menu>
      <v-btn
        color="grey darken-3"
        class="date-range-checked ma-0"
        outline
        @click="download()"
        >Download</v-btn
      >
    </v-toolbar>
    <v-expand-transition>
      <div v-show="expand">
        <v-data-table
          :headers="headers"
          :items="moduleData"
          :loading="loading"
          :pagination.sync="pagination"
          :rows-per-page-items="rowsPerPageItems"
          :total-items="totalItems"
          class="elevation-1"
          item-key="name"
        >
          <template v-slot:headers="props">
            <th
              v-for="header in props.headers"
              :key="header.text"
              v-if="!isToday && !header.isTodaySection"
              :class="[
                'column',
                !(typeof header.sortable === 'boolean' && !header.sortable)
                  ? 'sortable'
                  : '',
                header.align ? header.align : 'text-xs-left',
                pagination.descending ? 'desc' : 'asc',
                header.value === pagination.sortBy ? 'active' : '',
              ]"
              @click="changeSort(header)"
            >
              {{ header.text }}
              <v-icon
                small
                v-if="
                  !(typeof header.sortable === 'boolean' && !header.sortable)
                "
              >
                arrow_upward
              </v-icon>
            </th>

            <!-- today section -->
            <th
              v-for="header in props.headers"
              :key="header.text"
              v-if="
                isToday && !header.isLatestJob && !header.isMaintainExpiredDate
              "
              :class="[
                'column',
                !(typeof header.sortable === 'boolean' && !header.sortable)
                  ? 'sortable'
                  : '',
                header.align ? header.align : 'text-xs-left',
                pagination.descending ? 'desc' : 'asc',
                header.value === pagination.sortBy ? 'active' : '',
              ]"
              @click="changeSort(header)"
            >
              {{ header.text }}
              <v-icon
                small
                v-if="
                  !(typeof header.sortable === 'boolean' && !header.sortable)
                "
              >
                arrow_upward
              </v-icon>
            </th>
          </template>

          <template v-slot:items="props">
            <tr
              :active="props.selected"
              @click="props.selected = !props.selected"
              style="color: rgba(0, 0, 0, 0.87) !important"
            >
              <td class="text-xs-left">
                <div
                  style="
                    display: flex;
                    align-items: center;
                    gap: 4px;
                    height: 100%;
                  "
                >
                  <router-link
                    :to="{ name: 'Job', params: { id: props.item.id } }"
                    >{{ props.item.po_number }}</router-link
                  >
                </div>
              </td>

              <!-- to day section -->
              <template v-if="isToday">
                <td class="text-xs-center">
                  <router-link
                    :to="{ name: 'Job', params: { id: props.item.id } }"
                    >{{
                      props.item.latest_maintain_date
                        | morph-date("DD/MM/YYYY")
                    }}</router-link
                  >
                </td>
              </template>

              <td class="text-xs-center">
                <router-link
                  :to="{ name: 'Job', params: { id: props.item.id } }"
                  >{{
                    props.item.next_maintain_date | morph-date("DD/MM/YYYY")
                  }}</router-link
                >
              </td>

              <template v-if="!isToday">
                <td class="text-xs-center">
                  <router-link
                    :to="{ name: 'Job', params: { id: props.item.id } }"
                    >{{
                      props.item.maintain_expired_date
                        | morph-date("DD/MM/YYYY")
                    }}</router-link
                  >
                </td>
              </template>

              <td class="text-xs-center">
                <router-link
                  :to="{ name: 'Job', params: { id: props.item.id } }"
                  >{{
                    props.item.warranty_expired_date
                      | morph-date("DD/MM/YYYY")
                  }}</router-link
                >
              </td>

              <template v-if="!isToday">
                <td class="text-xs-center">{{ props.item.latest_job }}</td>
              </template>

              <!-- to day section -->
              <template v-if="isToday">
                <td class="text-xs-center">
                  {{
                    props.item.isCompleted === undefined ||
                    !!props.item.isCompleted
                      ? "Đã hoàn thiện"
                      : "Chưa hoàn thiện"
                  }}
                </td>

                <td class="text-xs-center">
                  <div
                    :style="[
                      getRemainingByToday(props.item) === 0
                        ? {
                            color: 'red',
                            fontWeight: 'bold',
                          }
                        : {},
                    ]"
                  >
                    {{ getRemainingByToday(props.item) }}
                  </div>
                </td>

                <td class="text-xs-center">
                  <div
                    style="
                      width: 20rem;
                      display: flex;
                      height: 100%;
                      align-items: center;
                      justify-content: center;
                    "
                  >
                    {{
                      props.item.assign_users
                        .map((user) => `${user.first_name} ${user.last_name}`)
                        .join(", ")
                    }}
                  </div>
                </td>

                <td class="text-xs-center">{{ props.item.note }}</td>
              </template>
            </tr>
          </template>
        </v-data-table>
      </div>
    </v-expand-transition>
  </div>
</template>
<script>
import PurchaseOrderService from "../services/purchase.order.service.js";
import {
  format,
  subDays,
  startOfDay,
  endOfDay,
  startOfToday,
  endOfToday,
  endOfTomorrow,
  startOfTomorrow,
  addDays,
  startOfMonth,
  getDaysInMonth,
  lastDayOfMonth,
  lastDayOfWeek,
} from "date-fns";
import * as _ from "lodash";
import { isEmpty } from "lodash";
import VDateRange from "./DateRange.vue";
import provinceList from "../config/provinces.js";
import * as json2csv from "json2csv";

export default {
  data() {
    return {
      expand: true,
      pagination: {
        rowsPerPage: 5,
        sortBy: "updatedAt",
        descending: true,
        totalItems: 0,
        page: 1,
      },
      dateMenu: false,
      range: [],
      labels: {
        start: "From " + this.title + " Date",
        end: "To " + this.title + " Date",
      },
      totalItems: 0,
      rowsPerPageItems: [5, 10, 25],
      pickerFrom: false,
      pickerTo: false,
      provincesSelected: [],

      dateRangeOptions: {
        startDate: format(new Date(), "YYYY-MM-DD"),
        endDate: format(subDays(new Date(), -14), "YYYY-MM-DD"),
        format: "MM/DD/YYYY",
        maxDate: format(subDays(new Date(), -730), "YYYY-MM-DD"),
        dayInNextMonth: getDaysInMonth(
          new Date().setMonth(new Date().getMonth() + 1)
        ),
        presets: [
          {
            label: "Today",
            range: [
              format(startOfToday(), "YYYY-MM-DD"),
              format(endOfToday(), "YYYY-MM-DD"),
            ],
          },
          {
            label: "Tomorrow",
            range: [
              format(startOfTomorrow(), "YYYY-MM-DD"),
              format(endOfTomorrow(), "YYYY-MM-DD"),
            ],
          },
          {
            label: "Next Week",
            range: [
              format(
                addDays(
                  lastDayOfWeek(new Date(), {
                    weekStartsOn: 1,
                  }),
                  1
                ),
                "YYYY-MM-DD"
              ),
              format(
                addDays(
                  lastDayOfWeek(new Date(), {
                    weekStartsOn: 1,
                  }),
                  7
                ),
                "YYYY-MM-DD"
              ),
            ],
          } /*
                    {
                        label: "Next 7 Days",
                        range: [
                            format(startOfTomorrow(), "YYYY-MM-DD"),
                            format(addDays(new Date(), 7), "YYYY-MM-DD")
                        ]
                    },*/,
          {
            label: "Next Month",
            range: [
              format(
                startOfMonth(new Date().setMonth(new Date().getMonth() + 1)),
                "YYYY-MM-DD"
              ),
              format(
                lastDayOfMonth(new Date().setMonth(new Date().getMonth() + 1)),
                "YYYY-MM-DD"
              ),
            ],
          },
        ],
      },
      purchaseOrderService: new PurchaseOrderService(),
      sortBy: "",

      loading: false,
      headers: [
        {
          text: "PO Number",
          value: "po_number",
        },
        {
          text: "Last Maintain Date",
          value: "latest_maintain_date",
          align: "text-xs-center",
          isTodaySection: true,
        },
        {
          text: "Next Maintain Date",
          value: "next_maintain_date",
          align: "text-xs-center",
        },
        {
          text: "Maintain Expired Date",
          value: "maintain_expired_date",
          align: "text-xs-center",
          isMaintainExpiredDate: true,
        },
        {
          text: "Warranty Expired Date",
          value: "warranty_expired_date",
          align: "text-xs-center",
        },
        {
          text: "Latest Job's Status",
          //sortable: true,
          value: "latest_job",
          align: "text-xs-center",
          isLatestJob: true,
        },
        {
          text: "Job's Status",
          //sortable: true,
          value: "latest_job",
          align: "text-xs-center",
          isTodaySection: true,
        },
        {
          text: "Remaining",
          value: "remaining_periodic_maintenance",
          align: "text-xs-center",
          isTodaySection: true,
        },
        {
          text: "User",
          value: "assign_users",
          align: "text-xs-center",
          isTodaySection: true,
        },
        {
          text: "Note",
          value: "next_maintain_date",
          align: "text-xs-center",
          isTodaySection: true,
        },
      ],
      moduleData: [],
    };
  },
  props: {
    title: {
      type: String,
      required: true,
    },
    dateInTitle: {
      type: Boolean,
      default: true,
    },
    disable: {
      type: Boolean,
      default: false,
    },
    by: {
      type: String,
      required: true,
    },
    future: {
      type: Boolean,
      default: false,
    },
    filter_date_by_1: {
      type: [String, undefined],
      required: false,
    },
    isToday: {
      type: [Boolean, undefined],
      default: false,
      required: false,
    },
  },
  computed: {
    provinces() {
      return provinceList;
    },
  },
  created() {
    if (this.future) {
      this.range = [
        format(new Date(), "YYYY-MM-DD"),
        format(subDays(new Date(), -14), "YYYY-MM-DD"),
      ];
    } else {
      this.range = [
        format(subDays(new Date(), 7), "YYYY-MM-DD"),
        format(new Date(), "YYYY-MM-DD"),
      ];
    }
    this.rangTemp = this.range;
    this.getData();
  },
  mounted() {},
  watch: {
    pagination: {
      handler(oldValue, newValue) {
        if (oldValue.descending !== newValue.descending)
          this.pagination.page = 1;
        if (!_.isEqual(oldValue, newValue)) this.getData();
      },
      deep: true,
    },
    provincesSelected() {
      this.getData();
    },
  },
  components: { VDateRange },
  methods: {
    changeSort(data) {
      if (typeof data.sortable === "boolean" && !data.sortable) return;
      const column = data.value;
      if (this.pagination.sortBy === column) {
        this.pagination.descending = !this.pagination.descending;
      } else {
        this.pagination.sortBy = column;
        this.pagination.descending = false;
      }
      this.pagination.page = 1;
      this.getData();
    },
    getData() {
      this.loading = true;
      let params = {
        page: this.pagination.page,
        limit: this.pagination.rowsPerPage,
        filter_date_by: this.by,
        filter_date_by_1: this.filter_date_by_1,
      };

      if (!this.disable) {
        params = Object.assign(
          params,
          { from: this.range[0] },
          { to: this.range[1] }
        );
      }
      if (!isEmpty(this.search)) params.search = this.search;

      if (!isEmpty(this.provincesSelected)) {
        params.provinces = this.provincesSelected.join(",");
      }

      params.from = startOfDay(new Date(params.from)).toISOString();
      params.to = endOfDay(new Date(params.to)).toISOString();

      if (this.pagination.sortBy) {
        params.sort =
          (this.pagination.descending ? "-" : "") + this.pagination.sortBy;
      }
      this.purchaseOrderService.getList(params).then((res) => {
        this.moduleData = res.docs;
        this.loading = false;
        this.totalItems = res.total;
      });
    },
    downloadData() {
      this.loading = true;
      let params = {
        from: this.range[0],
        to: this.range[1],
      };

      params.filter_date_by = this.by;
      params.filter_date_by_1 = this.filter_date_by_1;

      if (this.pagination.sortBy) {
        params.sort =
          (this.pagination.descending ? "-" : "") + this.pagination.sortBy;
      }

      if (!isEmpty(this.provincesSelected)) {
        params.provinces = this.provincesSelected.join(",");
      }

      params.from = startOfDay(new Date(params.from)).toISOString();
      params.to = endOfDay(new Date(params.to)).toISOString();

      this.purchaseOrderService.getAllList(params).then((res) => {
        this.loading = false;

        let arrData = [];
        let fileName = "";

        switch (this.by) {
          case "maintain":
            fileName = "maintain";
            arrData = res.map((doc) => {
              return {
                "PO Number": doc.po_number,
                "Next Maintain Date": format(
                  new Date(doc.next_maintain_date),
                  "DD/MM/YYYY"
                ),
                "Maintain Expired Date": format(
                  new Date(doc.maintain_expired_date),
                  "DD/MM/YYYY"
                ),
                "Warranty Expired Date": format(
                  new Date(doc.warranty_expired_date),
                  "DD/MM/YYYY"
                ),
                "Latest Job Status": doc.latest_job,
              };
            });
            break;
          case "next_maintain":
            fileName = "next_maintain";
            arrData = res.map((doc) => {
              return {
                "PO Number": doc.po_number,
                "Next Maintain Date": format(
                  new Date(doc.next_maintain_date),
                  "DD/MM/YYYY"
                ),
                "Maintain Expired Date": format(
                  new Date(doc.maintain_expired_date),
                  "DD/MM/YYYY"
                ),
                "Warranty Expired Date": format(
                  new Date(doc.warranty_expired_date),
                  "DD/MM/YYYY"
                ),
                "Latest Job Status": doc.latest_job,
              };
            });
            break;
          case "warranty":
            fileName = "warranty";
            arrData = res.map((doc) => {
              return {
                "PO Number": doc.po_number,
                "Next Maintain Date": format(
                  new Date(doc.next_maintain_date),
                  "DD/MM/YYYY"
                ),
                "Maintain Expired Date": format(
                  new Date(doc.maintain_expired_date),
                  "DD/MM/YYYY"
                ),
                "Warranty Expired Date": format(
                  new Date(doc.warranty_expired_date),
                  "DD/MM/YYYY"
                ),
                "Latest Job Status": doc.latest_job,
              };
            });
            break;
          case "latest_maintain_date":
            fileName = "today_maintain";
            arrData = res.map((doc) => {
              return {
                "PO Number": doc.po_number,
                "Last Maintain Date": format(
                  new Date(doc.latest_maintain_date),
                  "DD/MM/YYYY"
                ),
                "Next Maintain Date": format(
                  new Date(doc.next_maintain_date),
                  "DD/MM/YYYY"
                ),
                "Warranty Expired Date": format(
                  new Date(doc.warranty_expired_date),
                  "DD/MM/YYYY"
                ),
                "Job's Status":
                  doc.isCompleted === undefined || !!doc.isCompleted
                    ? "Đã hoàn thiện"
                    : "Chưa hoàn thiện",
                Remaining:
                  (doc.form_free_maintenance.remaining_periodic_maintenance ||
                    0) +
                  (doc.form_chargeable_maintenance
                    .remaining_periodic_maintenance || 0),
                User: doc.assign_users
                  .map((user) => `${user.first_name} ${user.last_name}`)
                  .join(", "),
              };
            });
            break;
        }
        const csvContent =
          "data:text/csv; charset=utf-8," +
          encodeURIComponent("\uFEFF" + json2csv.parse(arrData));

        const link = document.createElement("a");
        link.setAttribute("href", csvContent);
        link.setAttribute("download", `${fileName}.csv`);
        link.click();
      });
    },
    onDateRangeChange(range) {
      this.rangTemp = range;
    },
    filterDateRange() {
      this.range = this.rangTemp;
      this.from = this.rangTemp[0];
      this.to = this.rangTemp[1];
      this.dateMenu = false;
      this.getData();

      this.dateRangeOptions.startDate = this.from;
      this.dateRangeOptions.endDate = this.to;
    },
    download() {
      this.range = this.rangTemp;
      this.from = this.rangTemp[0];
      this.to = this.rangTemp[1];
      this.downloadData();
    },
    clickTile(e) {
      const t = e.target.classList.value;
      if (
        t === "v-toolbar__content" ||
        t === "v-toolbar__title" ||
        !this.expand
      ) {
        this.expand = !this.expand;
      }
    },
    cancelPicker() {
      this.dateMenu = false;
    },
    getRemainingByToday(item) {
      if (item.free_maintenance && item.chargeable_maintenance) {
        return (
          item.form_free_maintenance.remaining_periodic_maintenance +
          item.form_chargeable_maintenance.remaining_periodic_maintenance
        );
      } else if (item.free_maintenance) {
        return item.form_free_maintenance.remaining_periodic_maintenance;
      } else if (item.chargeable_maintenance) {
        return item.form_chargeable_maintenance.remaining_periodic_maintenance;
      }

      return 0;
    },
  },
};
</script>
<style>
#maintain .v-toolbar__title {
  font-size: 16px;
}
#maintain .date-range-checked {
  border: 1px solid rgba(0, 0, 0, 0.12);
}
.item-dashboard {
  cursor: pointer;
}
.v-input--selection-controls:not(.v-input--hide-details) .v-input__slot {
  margin: 0 !important;
}
.v-autocomplete__content .v-list__tile__action {
  min-width: auto !important;
}
.v-autocomplete .v-select__selections {
  flex-wrap: nowrap;
  overflow: auto;
}
</style>
